import { ofType, combineEpics } from 'redux-observable';
import {
  switchMap, map, catchError,
} from 'rxjs/operators';
import { errorHandler, httpGet } from '../../../../common/httpCall';
import {
  PROJECT_STAGES_TEMPLATES_GET_ATTEMPT,
  projectStagesTemplatesGetSuccess,
} from './stepOne.actions';

export const epicGetProjectStagesTemplates = (action$) => action$.pipe(
  ofType(PROJECT_STAGES_TEMPLATES_GET_ATTEMPT),
  switchMap(({ payload }) => httpGet({
    call: 'projects/stage_templates',
  }).pipe(
    map((result) => projectStagesTemplatesGetSuccess(result)),
    catchError((err) => errorHandler(err, payload.enqueueSnackbar)),
  )),
);

const stepOneEpic = combineEpics(
  epicGetProjectStagesTemplates,
);

export default stepOneEpic;
